import { isParamountInstance } from '@/theme/vars';
import { initaliseGA, sendEvent as sendGAEvent } from './ga';
import { sendEventV2 as sendInternalEvent } from './internal';

let initialised = false;

export async function init(gaId: string, amplitudeKey?: string) {
    // if (!initialised && gaId && amplitudeKey) {
    //     initaliseGA(gaId);
    //     setAmplitudeKey(amplitudeKey);
    //     initialised = true;
    // }
    try {
        if (!initialised && gaId && (await areAnalyticsAllowed())) {
            initaliseGA(gaId);
            initialised = true;
        }
    } catch (error) {}
}

export async function sendEvent(name: string, data?: string | Record<string, unknown>) {
    // Previously, this sent events to the old analytics system.
    // Many old files still call this function.
    // Any important analytics calling this should call sendEventV2 instead.
}

export async function sendEventV2(
    name: string,
    strings: string[] = [],
    numbers: number[] = [],
    isExternal?: boolean,
    useBeacon?: boolean,
) {
    try {
        sendInternalEvent(name, strings, numbers, isExternal, useBeacon);
        if (await areAnalyticsAllowed()) {
            sendGAEvent(name, {
                metadata: {
                    strings,
                    numbers,
                },
            });
        }
    } catch (error) {}
}

const sentEvents: Record<string, boolean> = {};
// Send the event only once per session
export function sendEventV2Once(...args: Parameters<typeof sendEventV2>) {
    const name = args[0];
    if (sentEvents[name]) return;
    sentEvents[name] = true;
    return sendEventV2(...args);
}

export async function areAnalyticsAllowed() {
    // Only paramount instances have cbsoptanon script currently
    if (!isParamountInstance) return true;
    try {
        return await window['cbsoptanon']?.ot?.getConsentPreferences(2);
    } catch (error) {
        console.log('areAnalyticsAllowed() - Could not getConsentPreferences so defaulting to false');
        return false;
    }
}
